<template>
  <v-card :loading="isLoading" :disabled="isLoading">
    <v-card-title>
      <v-row justify="space-between">
        <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.auctionDetail') }}</span>
          <v-btn icon @click.stop="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-tabs v-model="tab">
        <v-tab key="generalInfo">{{ $t('label.generalInformation') }}</v-tab>
        <v-tab key="routes">{{ $t('label.routes') }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item key="generalInfo">
          <v-container>
            <v-row>
              <v-col cols="12" sm="12">
                <v-text-field
                  v-model="auction.title"
                  :label="$t('label.auctionTitle')"
                  readonly
                  outlined
                  dense>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="12">
                <v-textarea
                  v-model="auction.description"
                  :label="$t('label.auctionDescription')"
                  rows="2"
                  readonly
                  outlined
                  dense>
                </v-textarea>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="auction.currentPrice"
                  :label="$t('label.currentPrice')"
                  prepend-inner-icon="mdi-currency-usd"
                  readonly
                  outlined
                  dense>
                </v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="auction.currencyType.code"
                  :label="$t('label.currency')"
                  readonly
                  outlined
                  dense>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="auction.truckType.shortDescription"
                  :label="$t('label.truckType')"
                  readonly
                  outlined
                  dense>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="auction.footprint.shortDescription"
                  :label="$t('label.footprint')"
                  readonly
                  outlined
                  dense>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="auction.startOn"
                  :label="$t('label.auctionStartDateTime')"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="auction.finishOn"
                  :label="$t('label.auctionFinishDateTime')"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="auction.requiredDate"
                  :label="$t('label.serviceProductRequiredDate')"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  outlined
                  dense>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  v-model="auction.requiredTime"
                  :label="$t('label.serviceProductRequiredTime')"
                  prepend-inner-icon="mdi-clock-outline"
                  readonly
                  outlined
                  dense>
                </v-text-field>
              </v-col>
              <v-col cols="12" v-if="auction.attachmentFileName">
                <v-text-field
                  v-model="auction.attachmentFileName"
                  :label="$t('label.attachment')"
                  outlined
                  readonly
                  append-outer-icon="mdi-download"
                  @click:append-outer="downloadFile"
                  dense>
                </v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item key="routes">
          <v-container>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="auction.sourceRoute"
                  :label="$t('label.startRoutePoint')"
                  readonly
                  outlined
                  dense>
                </v-text-field>
              </v-col>
            </v-row>
            <auction-routes :routes="auction.auctionRoutes"></auction-routes>
          </v-container>
        </v-tab-item>
      </v-tabs-items>

    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
        <v-btn small depressed @click.stop="close">{{ $t('label.close') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { loading, showMessage } from '../../../mixins'
import { extractDateTime, formatDateTime } from '../../../core/sharedFunctions'
import { saveAs } from 'file-saver'
import AuctionRoutes from './AuctionRoutes'

export default {
  name: 'AuctionDetail',
  props: {
    auctionId: Number,
    isActive: Boolean
  },
  components: { AuctionRoutes },
  mixins: [loading, showMessage],
  data: () => ({
    auction: {
      truckType: {},
      footprint: {},
      currencyType: {}
    },
    tab: null
  }),
  methods: {
    getAuction () {
      this.changeLoadingStatus(true)
      this.$proxy.get(`api/auctions/${this.auctionId}`)
        .then((r) => {
          this.auction = r.data
          // Set start date and time
          this.auction.startDate = this.auction.startDateTime.substring(0, 10)
          this.auction.startTime = this.auction.startDateTime.substring(11, 16)
          // Set start date and time
          this.auction.requiredDate = this.auction.requiredDateTime.substring(0, 10)
          this.auction.requiredDate = this.auction.requiredDate.replace(/-/g, '/')
          this.auction.requiredTime = this.auction.requiredDateTime.substring(11, 16)
          this.setDateTimes()
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.changeLoadingStatus(false)
        })
    },
    close () {
      this.$emit('close')
      this.tab = null
    },
    setDateTimes () {
      // Set finish on date
      const date = new Date(extractDateTime(this.auction.startDateTime))
      date.setTime(date.getTime() + (this.auction.hoursToExpire * 60 * 60 * 1000))
      this.$set(this.auction, 'finishOn', formatDateTime(date))
      // Set start on date
      this.$set(this.auction, 'startOn', formatDateTime(new Date(extractDateTime(this.auction.startDateTime))))
    },
    downloadFile () {
      this.$proxy.getDownload(`api/auctions/${this.auctionId}/attachment`)
        .then((r) => {
          saveAs(r.data, this.auction.attachmentFileName)
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
    }
  },
  watch: {
    auctionId: function (newVal, oldVal) {
      if (!this.isActive) {
        return
      }
      if (newVal) {
        this.auction = []
        this.getAuction()
      }
    }
  },
  mounted () {
    this.getAuction()
  }
}
</script>

<style>

</style>
